<template>
<div></div>
</template>

<script>
  import {clearParamsRedis} from '../../api/login'
    export default {
        name: "clearRedis",
      mounted() {
        clearParamsRedis();
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/clearRedis.vue